angular.module("dx.webapp.answer", [
	"dx.webapp.grade",
	"dx.webapp.question",

	"dx.ui.dataTypes.answer",
]);
